import { connect } from "react-redux";
import { validityIntervalReducer } from "./reducer/validityIntervalReducer";
import { selectFeatureToPortalEpic } from "./epic/selectFeatureToPortalEpic";
import { centerMapOnFeaturesEpic } from "./epic/centerMapOnFeaturesEpic";
import { updateFeatureGeometryOnPortalEpic } from "./epic/updateFeatureGeometryOnPortalEpic";
import { registerPlugin } from "../common/mapstore/registerPlugin";
import {
    PortalCommunicator,
    PortalCommunicatorDispatchProps,
    PortalCommunicatorStateProps,
} from "./PortalCommunicator";
import { RootState } from "../rootState";
import { editGeometryAction } from "../editFeature/redux/editGeometry";
import { viewGeometryAction } from "../editFeature/redux/viewGeometry";
import { updateValidityIntervalAction } from "./action/updateValidityIntervalAction";
import { selectFeatureFromPortalAction } from "./redux/select-feature/selectFeatureFromPortal.action";
import { reloadMapAction } from "../layers/action/reloadMapAction";
import { finishGeometryEditAction } from "../editFeature/redux/finishGeometryEdit";
import { deselectAllFeaturesAction } from "../feature/feature-detail-frame/redux/deselect-all-features/deselectAllFeatures.action";
import EnvParamsRetriever from "../common/util/EnvParamsRetriever";
import { portalReducer } from "./redux/portalReducer";
import { setSelectedLayersVisibleEpic } from "./epic/setSelectedLayersVisibleEpic";
import { sessionSelector } from "../session/redux/sessionSelector";
import { deselectFeatureFromPortalAction } from "./redux/deselect-feature/deselectFeatureFromPortal.action";
import { getDatasetFilterByIdActionCreator } from "../api/api-packages/getDataSetFilterById";
import { applyFeatureFilterAction } from "../filter/FeatureFilter/redux/apply-feature-filter/applyFeatureFilter.action";
import DataSetFilterItem from "../filter/DataSetFilter/dto/DataSetFilterItem";
import { validFromSelector } from "../common/selector/validityIntervalSelector";
import { viewSelector } from "../changes/selector/workspaceChangesSelector";
import { BASELINE_VIEW } from "../changes/changesConstants";
import { setCqlFilterAction } from "../layers/redux/cql-filter/setCqlFilter.action";
import { visibleQueryableLayersSelector } from "../common/selector/layerSelector";
import { zoomToPoint } from "mapstore2/web/client/actions/map";
import { Projection } from "../common/types";
import { loadSlotChangesActionCreator } from "../api/api-packages";
import { changesLoadedAction } from "../changes/redux/changesLoad/changesLoaded.action";
import { changesLoadingAction } from "../changes/redux/changesLoad/changesLoading.action";
import {setChangesGeneratedDateAction} from "../changes/redux/changeWorkspace";
import moment from "moment";
import {showError} from "../common/mapstore/action";

const mapStateToProps = (state: RootState): PortalCommunicatorStateProps => {
    let envData = "";
    if (state.featureLayersMapping?.receivedData) {
        envData = EnvParamsRetriever.getWorkspaceEnvParams(state).toRequestParams();
    }

    return {
        embeddedInPortal: state.urlParams.embeddedInPortal,
        featureLayersMapping: state.featureLayersMapping?.receivedData,
        visibleLayerNames: visibleQueryableLayersSelector(state).map((layer: { name: string }) => layer.name),
        envParams: envData,
        mapPresent: state.map?.present,
        ticket: sessionSelector(state),
        validFrom: validFromSelector(state),
        slots: viewSelector(state) === BASELINE_VIEW ? undefined : state.urlParams.slots,
        defaultZoom: state.mapInitialConfig?.zoom ?? 0,
    };
};

const deselectAllFeatures = (dispatch: any) => {
    dispatch(deselectAllFeaturesAction());
    dispatch(deselectFeatureFromPortalAction());
};

const mapDispatchToProps = (dispatch: any): PortalCommunicatorDispatchProps => {
    return {
        onUpdateValidityInterval: (from, to) => dispatch(updateValidityIntervalAction(from, to)),
        onFeaturesSelectedFromPortal: (features) => {
            deselectAllFeatures(dispatch);
            dispatch(selectFeatureFromPortalAction(features));
        },
        onDeselectAllFeatures: () => {
            deselectAllFeatures(dispatch);
        },
        onEditGeometry: (feature) => {
            deselectAllFeatures(dispatch);
            dispatch(editGeometryAction(feature));
        },
        onViewGeometry: (feature) => {
            deselectAllFeatures(dispatch);
            dispatch(viewGeometryAction(feature));
        },
        onReloadMap: () => {
            dispatch(setCqlFilterAction(undefined));
            dispatch(reloadMapAction());
        },
        onCancelGeometryEdit: () => {
            dispatch(setCqlFilterAction(undefined));
            dispatch(reloadMapAction());
            dispatch(finishGeometryEditAction());
        },
        onApplyFeatureFilter: (filterId, validFrom, slots) =>
            dispatch(getDatasetFilterByIdActionCreator({ id: filterId, validFrom: validFrom, slots: slots })),
        onApplyFeatureFilterAction: (item: DataSetFilterItem, filter: any) => {
            dispatch(applyFeatureFilterAction(item, filter));
        },
        onCenterToCoordinates: (coordinates, zoom) => dispatch(zoomToPoint(coordinates, zoom, Projection.EPSG_4326)),
        handleReloadChanges: (slots: string[] | string, forceReload: boolean) =>
            dispatch(loadSlotChangesActionCreator({ slotIds: slots, forceReload: forceReload })),
        handleChangesLoading: () => dispatch(changesLoadingAction()),
        handleChangesLoaded: () => dispatch(changesLoadedAction()),
        handleSetChangesGeneratedDateAction: (date: string) =>
            dispatch(setChangesGeneratedDateAction(moment(date).utc().format("YYYY-MM-DD HH:mm:ss"))),
        showError: (title, message) => dispatch(showError({ title: title, message: message, autoDismiss: 55 })),
    };
};

export const ConnectedPortalCommunicator = connect(mapStateToProps, mapDispatchToProps)(PortalCommunicator);

export const PortalCommunicatorPlugin = {
    name: "PortalCommunicatorPlugin",
    config: {
        component: ConnectedPortalCommunicator,
        reducers: {
            validityInterval: validityIntervalReducer,
            selectedFeaturesFromPortal: portalReducer,
        },
        epics: {
            selectFeatureToPortalEpic: selectFeatureToPortalEpic,
            centerMapOnFeaturesEpic: centerMapOnFeaturesEpic,
            updateFeatureGeometryOnPortalEpic: updateFeatureGeometryOnPortalEpic,
            setSelectedLayersVisibleEpic,
        },
    },
};
export const register = () => registerPlugin(PortalCommunicatorPlugin);
